import Header from "../Home/Header/Header"
import Breadcrumbs from "../BreadCrumbs";
import Hero from './Hero/Hero'

function Guarentee() {
    return (
        <div>
            <Header/>
            <Breadcrumbs/>
            <Hero/>
        </div>
    )
}

export default Guarentee